var body = document.getElementsByTagName('BODY')[0];
var htmlDoc = document.documentElement;
var regExp = /(^|=|\/)([0-9A-Za-z_-]{11})(\/|&|$|\?|#)/;

export { body, htmlDoc, regExp };